<template>
  <nav
    class="navbar is-fixed-top"
    role="navigation"
    aria-label="main navigation"
  >
    <div class="container">
      <base-button
        type="secondary"
        class="go-back-button"
        @click="goBack"
      >
        <base-icon iconRef="arrow-back" />
      </base-button>
      <div class="navbar-brand">
        <router-link
          class="navbar-item"
          to="/"
        >
          <base-icon
            position="left"
            iconRef="activity"
          />Sonar
        </router-link>

        <a
          role="button"
          class="navbar-burger burger"
          aria-label="menu"
          aria-expanded="false"
          data-target="sonar-navbar"
          :class="{ 'is-active': burgerMenuOpen }"
          @click="burgerMenuOpen = !burgerMenuOpen"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <div
        id="sonar-navbar"
        class="navbar-menu"
        :class="{ 'is-active': burgerMenuOpen }"
      >
        <div class="navbar-start">
          <router-link
            to="/"
            class="navbar-item"
          >
            Home
          </router-link>
          <router-link
            to="/klanten"
            class="navbar-item"
          >
            Klanten
          </router-link>
          <router-link
            to="/producten"
            class="navbar-item"
          >
            Producten
          </router-link>
          <router-link
            to="/admin"
            class="navbar-item"
            v-show="isCurrentUserAdmin"
          >
            Admin
          </router-link>
        </div>

        <div class="navbar-end">
          <a
            href="https://www.rivasono.nl"
            class="navbar-item"
            target="_blank"
          >
            <img
              src="/static/img/rivasono-logo.png"
              height="20"
              alt="Rivasono Logo"
            >
          </a>

          <div class="navbar-item has-dropdown is-hoverable">
            <a class="navbar-link">
              {{currentUserName}}
            </a>

            <div class="navbar-dropdown is-boxed is-right">
              <a
                class="navbar-item"
                @click="viewUpdates"
              >
                <base-icon
                  iconRef="calendar"
                  position="left"
                />Bekijk updates
              </a>
              <a
                class="navbar-item"
                @click="logOut"
              >
                <base-icon
                  iconRef="log-out"
                  position="left"
                />Log uit
              </a>
              <div class="navbar-item is-version">
                <span class="has-text-grey">Sonar <span class="has-text-primary">1.2.1</span></span>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import firebase from "firebase";

export default {
  name: "Navbar",
  data() {
    return {
      burgerMenuOpen: false,
      documentIsFullScreen: false
    };
  },
  computed: {
    userLoggedIn() {
      return this.$store.getters.getUser !== null;
    },
    isCurrentUserAdmin() {
      return this.$store.getters.getCurrentUserAdminStatus;
    },
    currentUser() {
      const currentUserUid = this.$store.getters.getUser.uid;
      const currentUser = this.$store.getters.getUsersList.find(
        user => user.data().uid == currentUserUid
      );
      return currentUser;
    },
    currentUserName() {
      return this.currentUser.data().firstName;
    }
  },
  methods: {
    viewUpdates() {
      this.$store.commit("setModalShown", {
        dataType: "changelog",
        modalType: "view",
        shown: true
      });
    },
    goBack() {
      this.$router.back();
    },
    logOut() {
      this.$dialog.confirm({
        message: "Weet je zeker dat je uit wilt loggen?",
        cancelText: "Annuleer",
        confirmText: "Log uit",
        onConfirm: () => {
          firebase
            .auth()
            .signOut()
            .then(() => {
              this.$store.dispatch("setUser");
              this.$router.replace("login");
            });
        }
      });
    },
    toggleAdminMode() {
      this.$store.commit("toggleAdminMode");
    }
  },
  mounted() {
    document
      .querySelectorAll(".navbar a:not(.navbar-burger)")
      .forEach(element => {
        element.addEventListener("click", () => {
          this.burgerMenuOpen = false;
        });
      });
    if (this.currentUser.data().lastReadUpdate != "15-02-2020") {
      this.$store.commit("setModalShown", {
        dataType: "changelog",
        modalType: "view",
        shown: true
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue